module.exports = __webpack_public_path__ + "static/img/djs.834433eb.png";